import { Reveal } from "@/components/Reveal";

export const About = () => (
  <section id="about" className="pt-28 lg:pt-40 pb-24 lg:pb-32" data-testid="about-section">
    <div className="px-5 lg:px-10">
      <Reveal>
        <h2 className="font-giant text-[11vw] lg:text-[7.5vw] leading-[0.9] text-[#121110]">
          SLOW <span className="font-swash text-[#A8512E] text-[9vw] lg:text-[6vw]">x</span> MAGIC
        </h2>
      </Reveal>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-24 mt-14 lg:mt-20 max-w-6xl">
        <Reveal delay={0.1}>
          <p className="text-lg lg:text-xl leading-relaxed text-[#121110]">
            After building <strong>Training Basket</strong> into a bridge for the skills gap,
            launching <strong>CoWorkZen</strong> into the coworking space, and bringing{" "}
            <strong>The Burger Company</strong> to Noida — I've learned one thing.
          </p>
          <p className="text-lg lg:text-xl leading-relaxed text-[#121110] mt-6">
            The loudest person in the room is rarely the one building the best thing.
          </p>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="text-lg lg:text-xl leading-relaxed text-[#4A453F]">
            I'm an introvert. I listen more than I speak, think longer than most, and commit
            fully once I do. Every vertical I enter, I enter to build something unique enough
            that customers don't just buy — they want to talk.
          </p>
          <p className="text-lg lg:text-xl leading-relaxed text-[#4A453F] mt-6">
            The goal: earn respect quietly, deliver results loudly.
          </p>
        </Reveal>
      </div>

      <div className="mt-28 lg:mt-40 relative">
        <div className="flex flex-col sm:flex-row gap-16 sm:gap-8 justify-between items-start">
          <Reveal>
            <h3 className="font-giant text-[14vw] sm:text-[10vw] lg:text-[6.5vw] leading-none">
              R<span className="font-swash text-[#A8512E] text-[11vw] sm:text-[8vw] lg:text-[5vw]">oo</span>TS
            </h3>
            <span className="pill mt-6 inline-flex" data-testid="roots-pill">1990 — Noida</span>
            <p className="max-w-xs text-[#4A453F] mt-6 leading-relaxed">
              B.Tech Civil, four years building government projects at NBCC — then walked away
              from the safe path in 2017 to become a full-time entrepreneur.
            </p>
          </Reveal>
          <Reveal delay={0.15} className="sm:text-right self-end sm:self-auto text-right">
            <h3 className="font-giant text-[14vw] sm:text-[10vw] lg:text-[6.5vw] leading-none">
              R<span className="font-swash text-[#A8512E] text-[11vw] sm:text-[8vw] lg:text-[5vw]">ou</span>TES
            </h3>
            <span className="pill mt-6 inline-flex" data-testid="routes-pill">Now — Everywhere</span>
            <p className="max-w-xs text-[#4A453F] mt-6 leading-relaxed ml-auto">
              London Business School's Entrepreneurial Edge, a growing network of founders,
              and three ventures that keep pulling me into new rooms — quietly.
            </p>
          </Reveal>
        </div>
        <svg className="w-full h-16 lg:h-24 mt-10" viewBox="0 0 1200 80" fill="none" preserveAspectRatio="none" aria-hidden="true">
          <path d="M0 40 C 300 40, 450 75, 600 40 S 900 5, 1200 40" stroke="#121110" strokeWidth="1.5" />
        </svg>
      </div>
    </div>
  </section>
);

export default About;
